module.exports = __webpack_public_path__ + "static/img/huangguan@2x.15c992e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newUi-icon/huangguan@2x.png
// module id = 06OV
// module chunks = 96